import styled from "styled-components/macro";
import { darkBlue } from "../../../constants/colors";
import { FONT_SIZE_SMALL } from "../../../constants/constants";

export const JoyrideContentStyles = styled.div`
  font-size: ${FONT_SIZE_SMALL}px;
  margin-bottom: -20px;
  text-align: left;
  display: grid;
  grid-gap: 10px;
  span.bold {
    font-weight: bold;
  }
  a {
    color: ${darkBlue} !important;
  }
  ol {
    list-style: decimal;
    padding-left: 2em;
  }
  li {
    padding-top: 0.6em;
    line-height: 1.2em;
  }
`;
